import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.5rem;
  height: 9rem;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.workSans};
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  align-self: center;
  margin-left: auto;
  display: flex;
  gap: 1rem;

  & > button {
    width: 23rem;
  }

  & > span.max-itens-excedeed {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.red};
    margin-right: 1rem;
  }
`;
